import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProductService, ProductServiceType } from '../models/productService';
import { Paginator } from '../models/paginator';
import { Trademark } from '../models/trademark';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductServiceService {

  constructor(
    private http: HttpClient
  ) {

  }

  retrieveAll(pageNumber: number, limit: number, offset: number, sort?: string, types?: ProductServiceType[], classNumbers?: number[], trademarks?: Partial<Trademark>[], query?: string): Promise<Paginator<ProductService>> {
    let params = new HttpParams()
      .set('page', pageNumber)
      .set('limit', limit)
      .set('offset', offset)

    if (sort) {
      params = params.set('sort', sort);
    }

    if (types) {
      types.forEach(type => {
        params = params.append('type[]', type);
      })
    }

    if (classNumbers) {
      classNumbers.forEach(classNumber => {
        params = params.append('classNumber[]', classNumber);
      })
    }

    if (trademarks) {
      trademarks.forEach(trademark => {
        if (trademark && trademark._id)
          params = params.append('trademark[]', trademark._id);
      })
    }

    if (query) {
      params = params.set('q', query);
    }
    return firstValueFrom(this.http
      .get<Paginator<ProductService>>(`${environment.backend}/productsAndServices/search`, { params }));
  }

  retrieveAllForDocument(documentId: string): Promise<ProductService[]> {
    return firstValueFrom(this.http
      .get<ProductService[]>(`${environment.backend}/productsAndServices/documents/${documentId}`));
  }

  retrieveByIds(ids: string[]) {
    const params = new HttpParams().appendAll({ ids });
    return firstValueFrom(
      this.http.get<ProductService[]>(
        `${environment.backend}/productsAndServices`,
        { params }
      )
    );
  }

  getLabel(productService: ProductService, lang?: string) {
    if (lang && lang === productService.lang) {
      return productService.label;
    } else if (lang && productService.translations[lang]) {
      return productService.translations[lang];
    } else {
      return productService.label;
    }
  }

}
